import React, { useEffect, useState } from 'react'
import { Button, Col, Image, Row, Table } from 'react-bootstrap'
import { BsPlusLg } from 'react-icons/bs'
import { getEducationAPI } from '../../../services/education'
import { useDispatch, useSelector } from 'react-redux'

import CreateEducationHistory from '../../employees/pim-detail/education-history-create'
import EditEducationHistory from '../../employees/pim-detail/education-history-edit'
import FileEducationTable from './file-education-table'
import iconEdit from '../../../images/Edit.svg'
import updateProfilePercent from '../../../helper/updateProfile-percent'
import { RecruitsAEpersonalEducationAPI } from '../../../services/recruit'
import { useDebounce } from '@react-hook/debounce'
import Autocomplete from '../../custom/autocomplete'
import UserecruitsAePersonal from '../../../hooks/use-recruit-ae-personal'
import ModalAddAeEducation from './modal-add-ae-education'
import { v4 as uuidv4 } from 'uuid'
import TableSkeletonBody from '../../custom/TableSkeletonBody'

function ProfileEducationHistory() {
  const profile = useSelector((state) => state.loginReducer.profile)
  const orgId = profile.org_id
  const code = profile.code
  const [dataTable, setDataTable] = useState([])
  const [showCreate, setShowCreate] = useState(false)
  const [showEdite, setShowEdite] = useState(false)
  const [showAE, setShowAE] = useState(false)
  const [isSave, setIsSave] = useState(false)
  const [detailTable, setDetailTable] = useState()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true)

  const [dataAe, setDataAe] = useState([])
  const [searchAE, setSearchAE] = useDebounce('', 1000)
  const codeAE = UserecruitsAePersonal(searchAE, code, orgId)
  useEffect(() => {
    profile && fnGetEducation()
  }, [profile])

  const fnSearchAE = async (aeNo) => {
    const param = {
      aeNo,
      orgId: profile.org_id
    }
    const resp = await RecruitsAEpersonalEducationAPI(param)
    if (!resp) return
    if (resp.status) {
      const newTable =
        resp.result.length > 0
          ? resp.result.map((d) => {
              return {
                id: uuidv4(),
                education_level: d.education_level,
                isEducationLevel: !!d.education_level,
                eduTypeId: d.education_level_id,
                eduName: d.education_name,
                isEduName: !!d.education_name,
                adYear: d.admission_year,
                isAdYear: !!d.admission_year,
                gradYear: d.graduation_year,
                isGradYear: !!d.graduation_year,
                eduBg: d.edu_bg,
                isEduBg: !!d.edu_bg,
                major: d.major,
                isMajor: !!d.major,
                grade: d.grade,
                isGrade: !!d.grade
              }
            })
          : []
      setDataAe(newTable)
      setShowAE(true)
    }
  }

  const fnGetEducation = async () => {
    setIsLoading(true)
    const result = await getEducationAPI({ orgId, code })
    setIsLoading(false)
    if (!result) return
    if (result.status) {
      setDataTable(result.result)
    }
  }

  return (
    <Row>
      <Col xl={12} className="d-flex justify-content-between mb-3">
        <span className="my-auto text-primary">Education History</span>

        <div className="d-flex">
          <div style={{ minWidth: 200 }} className="me-3">
            <Autocomplete
              isClearable={true}
              height={'32px'}
              placeholder={'Search AE No.'}
              options={codeAE}
              onInputChange={(data) => {
                setSearchAE(data.toUpperCase())
              }}
              onChange={(data) => {
                if (data) {
                  fnSearchAE(data.value)
                }
              }}
            />
          </div>

          <Button
            className="px-4 border-0"
            size="sm"
            onClick={() => setShowCreate(true)}
          >
            <BsPlusLg /> Add Education History
          </Button>
        </div>
      </Col>
      <Col className="">
        <Table responsive bordered hover className="mb-0">
          <thead className="bg-hrms text-white ">
            <tr>
              <th
                className="fw-normal small text-center align-middle"
                rowSpan={2}
              >
                #
              </th>
              <th className="fw-normal small align-middle" rowSpan={2}>
                Education Degree{' '}
              </th>

              <th className="fw-normal small align-middle" rowSpan={2}>
                Institution Name
              </th>

              <th className="fw-normal small text-center " colSpan={2}>
                Education Year
              </th>
              <th className="fw-normal small align-middle" rowSpan={2}>
                Educational Qualification
              </th>
              <th className="fw-normal small align-middle" rowSpan={2}>
                Faculty
              </th>
              <th className="fw-normal small align-middle" rowSpan={2}>
                Major
              </th>

              <th className="fw-normal small align-middle" rowSpan={2}>
                Grade
              </th>
              <th
                className="fw-normal small text-center align-middle"
                rowSpan={2}
              >
                <div>Transcript</div>
                <span className="fw-light">File </span>
                <span className="fw-light small ">(PDF Max 8 MB)</span>
              </th>
              <th
                className="fw-normal small text-center align-middle"
                rowSpan={2}
              >
                <div> Degree Graduated</div>
                <span className="fw-light">File </span>
                <span className="fw-light small ">(PDF Max 8 MB)</span>
              </th>
              <th
                className="fw-normal small text-center align-middle"
                rowSpan={2}
              >
                Edit
              </th>
            </tr>
            <tr>
              <th className="fw-normal small text-center">From</th>
              <th className="fw-normal small text-center">To</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <TableSkeletonBody colSpan={12} rowSpan={2} />
            ) : dataTable.length > 0 ? (
              dataTable.map((d, i) => (
                <tr key={i} className="fw-light font-small-2 ">
                  <td>{i + 1}</td>
                  <td>{d.education}</td>

                  <td>{d.edu_name}</td>
                  <td className="text-center">{d.admission_year}</td>
                  <td className="text-center">{d.graduation_year}</td>

                  <td>{d?.qualification ?? '-'}</td>
                  <td>{d.edu_bg}</td>

                  <td>{d.major}</td>

                  <td>{d.grade}</td>

                  {d.files.length > 0 ? (
                    d.files.map((f) => (
                      <>
                        <td className="text-center">
                          <FileEducationTable
                            educationId={d.id}
                            isFile={f.isFile}
                            idcode={{ orgId, code }}
                            fnData={fnGetEducation}
                            docTypeId={f.doc_type_id}
                          />
                        </td>
                      </>
                    ))
                  ) : (
                    <></>
                  )}
                  <td className="text-center">
                    <span className="me-2">
                      <Image
                        className=" pointer-event"
                        style={{
                          width: '20px'
                        }}
                        onClick={() => {
                          setDetailTable(d)
                          setShowEdite(true)
                        }}
                        src={iconEdit}
                      />{' '}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="fw-light ">
                <td colSpan={12} className="text-center">
                  - No data -
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>

      {showCreate ? (
        <CreateEducationHistory
          param={{ orgId, code }}
          setIsSave={setIsSave}
          showCreate={showCreate}
          isSave={isSave}
          fnGetWorks={fnGetEducation}
          setShowCreate={setShowCreate}
        />
      ) : (
        <></>
      )}
      {showEdite ? (
        <EditEducationHistory
          detail={detailTable}
          param={{ orgId, code }}
          setIsSave={setIsSave}
          showCreate={showEdite}
          isSave={isSave}
          fnGetWorks={fnGetEducation}
          setShowCreate={setShowEdite}
        />
      ) : (
        <></>
      )}

      {showAE && (
        <ModalAddAeEducation
          orgId={orgId}
          code={code}
          showAE={showAE}
          setShowAE={setShowAE}
          dataAe={dataAe}
          setDataAe={setDataAe}
          isSave={isSave}
          setIsSave={setIsSave}
          fnGetEducation={fnGetEducation}
          dispatch={dispatch}
          updateProfilePercent={updateProfilePercent}
        />
      )}
    </Row>
  )
}

export default ProfileEducationHistory
